import { useCallback } from "react";

const STORAGE_KEY_PREFIX = "vizops:diagram-layout:v1";

const storageKey = (userId) =>
  userId ? `${STORAGE_KEY_PREFIX}:${userId}` : null;

const readAll = (userId) => {
  const key = storageKey(userId);
  if (!key) return {};
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
};

const writeAll = (userId, data) => {
  const key = storageKey(userId);
  if (!key) return;
  try {
    localStorage.setItem(key, JSON.stringify(data));
  } catch {
    // quota or disabled storage — ignore
  }
};

export const useNodeLayoutPersistence = (userId, projectId) => {
  const getPositions = useCallback(() => {
    if (!userId || !projectId) return {};
    const all = readAll(userId);
    return all[projectId] || {};
  }, [userId, projectId]);

  const savePosition = useCallback(
    (nodeId, position) => {
      if (!userId || !projectId || !nodeId || !position) return;
      const all = readAll(userId);
      const forProject = all[projectId] || {};
      forProject[nodeId] = { x: position.x, y: position.y };
      all[projectId] = forProject;
      writeAll(userId, all);
    },
    [userId, projectId]
  );

  const clearPositions = useCallback(() => {
    if (!userId || !projectId) return;
    const all = readAll(userId);
    if (all[projectId]) {
      delete all[projectId];
      writeAll(userId, all);
    }
  }, [userId, projectId]);

  return { getPositions, savePosition, clearPositions };
};

export default useNodeLayoutPersistence;
